import React, { useEffect, useState } from 'react';
import { tryFetch } from '../../../../Helpers/FetchAPI';
import '../../../../styles/ProdReviews.scss';
import ReviewImageViewer from './revImageViewer';

interface ReviewImage {
  id: string;
  media_url: string;
}

interface Review {
  product_rating: string;
  product_remarks: string;
  customer_name: string;
  created_at: string;
  images: ReviewImage[];
}

interface ReviewData {
  average_rating: string;
  product_reviews: Review[];
}

interface Props {
  merchantId: string;
  blockId: string;
}

const ProductReviews: React.FC<Props> = ({ merchantId, blockId }) => {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [averageRating, setAverageRating] = useState<string>('0');
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await tryFetch({
          url: `/merchant/${merchantId}/product/${blockId}/reviews`,
          method: 'GET',
        });

        console.log('Review API data:', response.data);

        if (
          response.is_success &&
          response.data &&
          typeof response.data === 'object' &&
          'average_rating' in response.data &&
          'product_reviews' in response.data
        ) {
          const data = response.data as ReviewData;
          setAverageRating(data.average_rating);
        //   setReviews(data.product_reviews || []);

        const sortedReviews = [...(data.product_reviews || [])].sort(
        (a, b) => Number(b.product_rating) - Number(a.product_rating)
        );
        setReviews(sortedReviews);
        }
      } catch (error) {
        console.error('Error fetching reviews:', error);
      } finally {
        setFetched(true);
      }
    };

    fetchReviews();
  }, [merchantId, blockId]);
  if (!fetched) return null;

 return (
  <div className="product-reviews">
    <div className="reviews-header">
      <h2>Reviews</h2>
    </div>
    {reviews.length === 0 ? (
  <p>No reviews yet.</p>
) : (
  <div className="reviews-slider">
    {reviews.map((review, index) => (
      <div key={index} className="review-entry">
        <div className="review-meta">
          <span className="stars">{'★'.repeat(Number(review.product_rating))}</span>
          <span className="date">{new Date(review.created_at).toLocaleString()}</span>
        </div>

        <div className="review-content">
          <div className="text-group">
            {review.product_remarks && (
              <p className="review-remarks">{review.product_remarks}</p>
            )}
            <p className="review-name">{review.customer_name}</p>
          </div>
          {review.images && review.images.length > 0 && (
            <div className="review-image-wrapper">
              <ReviewImageViewer images={review.images} />
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
)}
  </div>
);

};

export default ProductReviews;
